<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-content">
        <div class="card-List">
          <div style="padding: 0 0 20px 42px">
            <div class="tabs">
              <div
                v-for="(item, index) in tabsList"
                :key="index"
                class="tabs-item"
                :class="{ active: editableTabsValue == item.value }"
                @click="change(item.value)"
              >
                {{ item.label }}
              </div>
            </div>
          </div>
          <div
            v-for="item in cardList"
            :key="item.shopMemberCardId"
            class="card-item"
            :style="{
              background: `linear-gradient(to bottom right, ${item.startValue}, ${item.endValue})`,
            }"
            @click="updateMemberCard(item)"
          >
            <img class="card-bg" src="@/assets/img/vip/pattern.png" alt />
            <span class="card-name" :style="{ color: `${item.textColor}` }">{{
              item.cardName
            }}</span>
            <span class="tips">{{ item.cardSlogan }}</span>
            <span class="discount">{{ item.discount }}折</span>
            <span class="endtime"
              >有效期：{{
                item.expireType == 0
                  ? "永久"
                  : item.expireType == 1
                  ? item.expireDayNum
                  : item.endTime
              }}</span
            >
            <span
              class="set-equity"
              @click.stop="
                linkTo(`/vip/equityManage?shopMemberCardId=${item.shopMemberCardId}`)
              "
              >配置权益</span
            >
          </div>
          <!-- <div class="no-data" v-if="!cardList.length">请到网付添加会员卡</div> -->
          <div class="add-vip">
            <img
              style="margin-left: 20px"
              @click="createdVipCard"
              src="../assets/img/vip/tjhyk.png"
              alt
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getShopMemberCardList } from "@/api/index.js";
import { commonFuc } from "@/mixins/commonFuc";
export default {
  mixins: [commonFuc],
  data() {
    return {
      cardList: [],
      editableTabsValue: 1,
      tabsList: [
        { value: "1", label: "可用" },
        { value: "0", label: "不可用" },
      ],
    };
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    getPageData() {
      this.getShopMemberCardList(1);
    },
    change(val) {
      console.log(val);
      this.editableTabsValue = val;
      this.getShopMemberCardList(val);
    },
    getShopMemberCardList(isEnable) {
      getShopMemberCardList({
        row: 1000,
        isEnable: isEnable,
      }).then((res) => {
        if (res.code == 1) {
          res.data.forEach((val) => {
            val.discount = (val.discount * 10).toFixed(1);
          });
          this.cardList = res.data;
        }
        if (res.code == -1) {
          this.cardList = [];
        }
      });
    },
    isExpire(data) {
      if (data.expireType == 1) {
        if (data.expireDayNum <= 0) {
          return false;
        }
      }
      if (data.expireType == 2) {
        if (+new Date(data.endTime) - +new Date() <= 0) {
          return false;
        }
      }
      return true;
    },
    createdVipCard() {
      this.$router.push({
        path: "/vip/addVipcard",
        query: { style: "create" },
      });
    },
    updateMemberCard(item) {
      console.log(item, "updateMemberCard");
      this.$router.push({
        path: "/vip/addVipcard",
        query: { style: "update" },
      });
      localStorage.setItem("singleVipNews", JSON.stringify(item));
    },
  },
};
</script>

<style lang="less" scoped>
.bd {
  height: 100%;
  .tab-content {
    height: 100%;
    padding-top: 20px;
    height: 100%;
    box-sizing: border-box;
    overflow: auto;
    .card-List {
      width: 100%;
      .tabs {
        display: inline-block;
        .tabs-item {
          float: left;
          width: 50px;
          height: 35px;
          padding: 0 15px;
          border: 1px solid #e4e7ed;
          line-height: 35px;
          text-align: center;
          margin-right: -1px;
          color: #909399;
          font-size: 14px;
          cursor: pointer;
          &.active {
            border-color: #409eff;
            border-bottom: transparent;
            color: #409eff;
            margin-right: 0;
          }
          &:last-child {
            position: relative;
            &::after {
              display: inline-block;
              content: "";
              border-bottom: 1px solid #e4e7ed;
              width: calc(100vw - 450px);
              position: absolute;
              top: 35px;
              left: 81px;
            }
          }
        }
      }
      .card-item {
        width: 297px;
        height: 172px;
        border-radius: 20px;
        display: inline-block;
        vertical-align: middle;
        position: relative;
        margin-left: 40px;
        margin-bottom: 20px;
        box-shadow: -2px 8px 30px #afafaf;
        & > span {
          position: absolute;
        }
        button + & {
          margin-top: 20px;
        }
        .card-bg {
          top: 50%;
          position: absolute;
          left: -25%;
          transform: translateY(-50%);
        }
        .card-name {
          font-size: 20px;
          font-weight: bold;
          left: 20px;
          top: 20px;
        }
        .tips {
          font-size: 14px;
          color: #fafafa;
          left: 20px;
          top: 54px;
        }
        .discount {
          font-size: 30px;
          color: #fafafa;
          top: 54px;
          right: 20px;
        }
        .endtime {
          font-size: 14px;
          color: #fafafa;
          left: 20px;
          bottom: 20px;
        }
        .set-equity {
          font-size: 14px;
          color: #fafafa;
          right: 20px;
          bottom: 20px;
          cursor: pointer;
        }
      }
    }
    .no-data {
      text-align: center;
      line-height: 40px;
      font-size: 20px;
    }
  }
}
.add-vip {
  height: 125px;
  width: 196px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
</style>
